import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import * as v3Adapter from "./adapter/v3";
import { secureConnectionQueryOptions } from "./api/secure-connection-query-options";

interface Options {
  enabled?: boolean;
}

// Non-admin equivalent of useSendingConnections for populating the share dialog
// and file-details sync views. Backed by the shareable-connections endpoint any
// authenticated user may call, so non-admins can list connections to share to.
export function useShareableSendingConnections({ enabled = true }: Options = {}) {
  const query = useInfiniteQuery({
    ...secureConnectionQueryOptions.shareableSendingListInfinite(),
    select: (data) => data.pages.flatMap((page) => page.items.map(v3Adapter.toShareableSendingConnection)),
    enabled,
  });

  const { hasNextPage, isFetchingNextPage, fetchNextPage, isError } = query;

  // Callers filter and resolve shared-with membership client-side, so drain every page.
  useEffect(() => {
    if (enabled && hasNextPage && !isFetchingNextPage && !isError) {
      void fetchNextPage();
    }
  }, [enabled, hasNextPage, isFetchingNextPage, isError, fetchNextPage]);

  return query;
}
